/**
 * Created by Alex Aguilar on 7/26/2016.
 */
(function(){
    'use strict';

    var tab = {
        transclude: true,
        template: '<div class="tab-pane" ng-show="vm.tab.selected" ng-transclude></div>',
        controller: tabController,
        controllerAs: 'vm',
        require: {
            'parent': '^tabs'
        },
        bindings:{
            heading: '@',
            target: '@',
            stateForm: '='
        }
    };

    angular
        .module('completeAir')
        .component('tab', tab);

    function tabController(){
        var vm = this;

        vm.$onInit = function(){

            if(vm.stateForm == undefined || vm.stateForm == ""){
                vm.state = false;
            }

            vm.tab = {
                heading: vm.heading,
                target: vm.target,
                stateForm: vm.stateForm,
                selected: false
            };

            vm.parent.addTab(vm.tab);
        }

        vm.$onDestroy = function(){
            if (vm.target) {
                vm.parent.removeTab(vm.target.substring(3))
            }
        }
    }
})();

